module.exports = __webpack_public_path__ + "static/app-qr-code-test-ef35dfb536c6673c7dd49f8e88d7a1b7.png";